module.exports = __webpack_public_path__ + "img/matan-logo.37287932.png";